import classNames from 'classnames'
import { forwardRef } from 'react'

import { useFocused } from './helpers/useFocused'
import { InputWrap } from './InputWrapper'
import { ITextareaProps, TextareaRef } from './models/ITextArea'

import styles from './Input.module.scss'
import textAreaStyles from './TextArea.module.scss'

export const Textarea = forwardRef<TextareaRef, ITextareaProps>(
  (
    {
      classes,
      margin,
      label,
      value,
      wrapper,
      disabled,
      startContent,
      endContent,
      dir,

      id,
      autoFocus,
      placeholder,
      placeholderTemplate,
      autocompleteOff,
      autoComplete,
      ariaLabel,
      maxLength,
      onChange,
      onFocus,
      onBlur,
      onSelect,

      onKeyPress,
      onKeyDown,
      rows,
      resizable = 'vertical',

      __testId,
    },
    ref
  ) => {
    const { focused, setFocused } = useFocused({ disabled })

    return (
      <InputWrap
        classes={classes}
        margin={margin}
        label={label}
        value={value}
        wrapper={wrapper}
        disabled={disabled}
        startContent={startContent}
        endContent={endContent}
        dir={dir}
        focused={focused}
        textarea
        customTemplates={{
          root: ({ children }) => {
            return (
              <div
                className={classNames(
                  textAreaStyles['text-area-content-wrapper'],
                  classes?.content || ''
                )}
                data-testid={'textareaContent'}
              >
                {placeholderTemplate ? (
                  <div
                    className={classNames(styles.customPlaceholder, {
                      [styles['customPlaceholder--hidden']]: !!value,
                    })}
                  >
                    {placeholderTemplate()}
                  </div>
                ) : null}
                {children}
              </div>
            )
          },
        }}
      >
        <textarea
          dir={dir}
          data-testid={__testId}
          autoComplete={autocompleteOff ? 'disable' : autoComplete}
          aria-label={ariaLabel}
          maxLength={maxLength}
          className={classNames(
            textAreaStyles.textarea_control,
            styles.control,
            styles['control--textarea'],
            {
              [styles['control--focused']]: label && (focused || value),
              [textAreaStyles['textarea_resizable_vertical']]: resizable === 'vertical',
              [textAreaStyles['textarea_unresizable']]: resizable === 'none',
            },
            classes?.control
          )}
          id={id}
          ref={ref}
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value as string}
          disabled={disabled}
          onFocus={() => {
            setFocused(true)
            onFocus && onFocus()
          }}
          onBlur={(e: any) => {
            setFocused(false)
            onBlur && onBlur(e)
          }}
          autoFocus={autoFocus}
          onSelect={onSelect}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          rows={rows}
        />
      </InputWrap>
    )
  }
)
